import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/pages/Team.tsx");
